import React, { useState } from "react";
import { Menu, Close, Person, ExitToApp } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const logo = require('../assets/images/solis-logo.png');

const Header = ({ showSideBar = true, onToggleSideBar = () => { } }) => {
  const { user, isManager, logout, navigationConfig } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  return (
    <div className="header">
      <div className="pb-1" style={{ background: '#25A3DD' }}></div>
      <div className="p-3 flex items-center" style={{ background: '#0F1F43' }}>
        {/* Left Section */}
        <div className="basis-1/4 flex space-x-5 items-center">
          <img src={logo} className="h-12 w-12" alt="Logo" />
          <div className="flex flex-col">
            <div className="text-xl text-gray-200 uppercase font-bold">Collections</div>
            {user && (
              <div className={`text-xs font-semibold px-2 py-0.5 rounded mt-1 inline-block w-fit ${
                isManager
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-500 text-white'
              }`}>
                {isManager ? 'Collections Manager' : 'Collections Agent'}
              </div>
            )}
          </div>
        </div>

        {/* Middle Section */}
        <div className="basis-1/2 text-center text-cyan-200">
          <ul className="flex justify-center space-x-12 text-xs uppercase">
            {navigationConfig?.headerNav?.map((item, index) => (
              <li key={index}>
                <Link to={item.path}>{item.label}</Link>
              </li>
            )) || (
              <>
                <li><a href="">Assignment Dashboard</a></li>
                <li><a href="">Collections Pipeline</a></li>
                {isManager && <li><Link to="/manage-team">Manage Team</Link></li>}
                <li><a href="">Settings</a></li>
              </>
            )}
          </ul>
        </div>

        {/* Right Section */}
        <div className="basis-1/4 flex justify-end items-center space-x-4">
          {user && (
            <div className="text-white text-sm">
              {user.firstName} {user.lastName}
            </div>
          )}
          <div className="relative">
            <Person
              className="cursor-pointer bg-white text-black p-1 rounded-full"
              onClick={() => setShowUserMenu(!showUserMenu)}
            />
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                <div className="px-4 py-2 text-sm text-gray-700 border-b">
                  <div className="font-semibold">{user?.firstName} {user?.lastName}</div>
                  <div className="text-xs text-gray-500">{user?.email}</div>
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
                >
                  <ExitToApp fontSize="small" />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="p-3 flex items-center border-b bg-white">
        {/* Left Section */}
        <div className="flex space-x-5 items-center">
          {showSideBar ? (
            <Close className="cursor-pointer" onClick={() => onToggleSideBar(showSideBar)} />
          ) : (
            <Menu className="cursor-pointer" onClick={() => onToggleSideBar(showSideBar)} />
          )}
        </div>

        {/* Right Section */}
        <span className="text-xs ml-auto text-gray-400">
          Last updated: 3 mins ago
        </span>
      </div>
    </div>
  );
};

export default Header;